import { ErrorParser } from "../ErrorParser";
import { isObject } from "lodash-es";

/**
 * Ej: 'wrong next_question in question 12'
 */
export class SiguientePreguntaMalParser implements ErrorParser {
    public puedeLeerError(error: string): boolean {
        return !isObject(error) && error.includes("wrong next_question in question");
    }

    public traducir(error: string): string {
        const numeroPregunta = parseInt(error.replace("wrong next_question in question", "").trim(), 10);
        return `El siguiente pregunta de la pregunta ${numeroPregunta} esta mal`;
    }
}
